<template>
  <div class="popover-option-li">
    <div class="popover-option-li__left">
      <slot name="left-icon" />
    </div>
    <div class="popover-option-li__content">
      <slot />
    </div>
    <div class="popover-option-li__right">
      <slot name="right-icon" />
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.popover-option-li {
  padding: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;

  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--neutral-translucent-5, rgba(39, 45, 55, 0.051));
  }

  &:active {
    background-color: var(--neutral-translucent-10);
  }

  &__content {
    color: var(--text-primary, #272d37);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
  }
  &__left,
  &__right {
    width: 1.5rem;
    height: 1.5rem;

    &:empty {
      display: none;
    }
  }

  &__right {
    margin-left: auto;
  }
}
</style>
